import { Component, Input } from '@angular/core'
import { NgTemplateOutlet, LowerCasePipe } from '@angular/common'

export interface InterestRates {
  relationship: string
  benchmark: string
  cash_and_pik: string
  cash_exact_percentage: number
  cash_max_percentage: number
  cash_min_percentage: number
  pik_exact_percentage: number
  pik_max_percentage: number
  pik_min_percentage: number
  default_incremental_percentage: number
}

@Component({
    selector: 'interest-rates',
    templateUrl: './interest-rates.component.html',
    styleUrls: ['./interest-rates.component.css'],
    imports: [NgTemplateOutlet, LowerCasePipe]
})


export class InterestRatesComponent {

  @Input() rates: InterestRates[] = []


  parseFloat(s: string) : number {
    return parseFloat(s)
  }
}
